import i18n from "../localization/localization"

export const getTranslation = (key: string, namespace: string) => {
    return i18n.t(key, {ns : namespace})
}

export const getCommonTranslation = (key: string) => {
    return getTranslation(key, "translation");
}

export const getToastTranslation = (key: string) => {
    return getTranslation(key, "toast");
}